import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getHomeBanner = createAsyncThunk(
    'home/banner',
    async (_, { rejectWithValue }) => {
        try {
            const bannerData = await GET(API.GET_HOME_BANNERS);
            return bannerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const getLocateStore = createAsyncThunk(
    'home/store',
    async (_, { rejectWithValue }) => {
        try {
            const bannerData = await GET(API.GET_ALL_LOCATESTORE);
            return bannerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const getHomeHeader = createAsyncThunk(
    'home/header',
    async (_, { rejectWithValue }) => {
        try {
            const bannerData = await GET(API.GET_HOME_HEADERS);
            return bannerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const getAddBanner = createAsyncThunk(
    'home/add-banner',
    async (_, { rejectWithValue }) => {
        try {
            const bannerData = await GET(API.GET_ADVERTISMENT_BANNERS);
            return bannerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Thunk for getting Add banners
export const getCoupons = createAsyncThunk(
    'home/add-coupons',
    async ({ amount='' }, { rejectWithValue }) => {
        try {
            const couponData = await GET(`${API.COUPON}?amount=${amount}`);

            return couponData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const getWhy_Choose_Us = createAsyncThunk(
    'home/add-whychooseus',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.GET_Why_Choose_Us);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



// Thunk for getting Add banners
export const getNeeds = createAsyncThunk(
    'home/add-needs',
    async (_, { rejectWithValue }) => {
        try {
            const needsData = await GET(API.GET_Needs);
            return needsData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Thunk for getting Add banners
export const getPartners = createAsyncThunk(
    'home/add-partners',
    async (_, { rejectWithValue }) => {
        try {
            const partnersData = await GET(API.GET_Partners);
            return partnersData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getOfferProduct = createAsyncThunk(
    'home/offer-product',
    async (_, { rejectWithValue }) => {
        try {
            const partnersData = await GET(API.GET_OFFER_PRODUCT);
            return partnersData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getcount = createAsyncThunk(
    'home/count',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.Count);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getRating = createAsyncThunk(
    'home/rating',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.rating);
            //console.log("THUNK RECEIVED:", whyprintoutData);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const getcuttingedge = createAsyncThunk(
    'home/cuttingedge',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.cuttingedge);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getMatressfeel = createAsyncThunk(
    'home/matress',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.mattressfeel);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getSize = createAsyncThunk(
    'home/size',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.size);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getheight = createAsyncThunk(
    'home/height',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.height);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getbestOffer = createAsyncThunk(
    'home/bestoffer',
    async (_, { rejectWithValue }) => {
        try {
            const whyprintoutData = await GET(API.bestOffer);
            return whyprintoutData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const homeSlice = createSlice({
    name: "home",
    initialState: {
        name: '',
        image: '',
        banners: [],
        headers: [],
        addBanners: [],
        addCoupons: [],
        addWhyChooseUs: [],
        addNeeds: [],
        addPartners: [],
        count:[],
        rating:[],
        cuttingedge:[],
        mattressfeel:[],
        size:[],
        height:[],
        bestoffer:[],
        all_offer_product: [],
        locatestores: [],
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getHomeBanner.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getHomeBanner.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.banners = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getHomeBanner.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })


            .addCase(getHomeHeader.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getHomeHeader.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.headers = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getHomeHeader.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

            .addCase(getbestOffer.pending, (state) => {
                state.status = 'loading';
                //  console.log('State after pending Ratingd', state);
            })
            .addCase(getbestOffer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.bestoffer = action.payload?.data || [];
                //  console.log('State after fulfilled Ratingd',  state.rating);
            })
            .addCase(getbestOffer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected Ratingd', state);
            })



            .addCase(getLocateStore.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getLocateStore.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.locatestores = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getLocateStore.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })


            .addCase(getRating.pending, (state) => {
                state.status = 'loading';
                //  console.log('State after pending Ratingd', state);
            })
            .addCase(getRating.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.rating = action.payload?.data || [];
                //  console.log('State after fulfilled Ratingd',  state.rating);
            })
            .addCase(getRating.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected Ratingd', state);
            })

            .addCase(getcuttingedge.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getcuttingedge.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.cuttingedge = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getcuttingedge.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })
             
             .addCase(getMatressfeel.pending, (state) => {
                state.status = 'loading';
                //  console.log('State after pending Ratingd', state);
            })
            .addCase(getMatressfeel.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.mattressfeel = action.payload?.data || [];
                //  console.log('State after fulfilled Ratingd',  state.rating);
            })
            .addCase(getMatressfeel.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected Ratingd', state);
            })
            .addCase(getSize.pending, (state) => {
                state.status = 'loading';
                //  console.log('State after pending Ratingd', state);
            })
            .addCase(getSize.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.size = action.payload?.data || [];
                //  console.log('State after fulfilled Ratingd',  state.rating);
            })
            .addCase(getSize.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected Ratingd', state);
            })

              .addCase(getheight.pending, (state) => {
                state.status = 'loading';
                //  console.log('State after pending Ratingd', state);
            })
            .addCase(getheight.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.height = action.payload?.data || [];
                //  console.log('State after fulfilled Ratingd',  state.rating);
            })
            .addCase(getheight.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected Ratingd', state);
            })

            .addCase(getAddBanner.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getAddBanner.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addBanners = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getAddBanner.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

            .addCase(getCoupons.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getCoupons.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addCoupons = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getCoupons.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

            .addCase(getWhy_Choose_Us.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getWhy_Choose_Us.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addWhyChooseUs = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getWhy_Choose_Us.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })


            .addCase(getNeeds.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getNeeds.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addNeeds = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getNeeds.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })


            .addCase(getPartners.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getPartners.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addPartners = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getPartners.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

            .addCase(getOfferProduct.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getOfferProduct.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.all_offer_product = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getOfferProduct.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

            .addCase(getcount.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getcount.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.count = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getcount.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })
            ;
    },
});

export default homeSlice.reducer;


